import {AccountingManualService} from "../../../services/documents/AccountingManualService";
import {
    AccountingManualTransactionsDetail
} from "../../../components/Pages/Documents/AccountingManualTransactions/AccountingManualTransactionsDetail";
import React from "react";
import {IAppEntity} from "../../entities";
import {ReferenceTypes} from "../../../enums/ReferenceTypes";
import {
    CreateAccountingManualTransactionsDto
} from "../../../dtos/documents/AccountingManualTransactions/CreateAccountingManualTransactionsDto";
import {
    NFLookupAccountingManualTransactions
} from "../../../components/Shared/NewForms/NFLookupAccountingManualTransactions";
import AccountingManualTransactionsList
    from "../../../components/Pages/Documents/AccountingManualTransactions/AccountingManualTransactionsList";

export const AccountingManualTransactions: IAppEntity = {
    entityType: "document",
    title: "Accounting Manual Transactions",
    pluralTitle: "Accounting Manual Transactions List",
    apiUrl: "AccountingManualTransactions",
    apiEnum: ReferenceTypes.DocumentAccountingManualTransaction,

    getDetailViewComponent: (
        model: any,
        modelUpdatedEvent: (model: any) => void
    ) =>
        React.createElement(AccountingManualTransactionsDetail, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        }),
    getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
        React.createElement(AccountingManualTransactionsList, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        }),
    getLookupComponent(model: any): any {
        return React.createElement(NFLookupAccountingManualTransactions, {
            fieldName: model.fieldName,
            title: model.title,
            setSelectedCatalog: model.setSelectedCatalog,
        });
    },
    getDataService: () =>
        new AccountingManualService("AccountingManualTransactions"),
    getEmptyModel: () => {
        const model: CreateAccountingManualTransactionsDto = {
            totalAmount: 0,
            totalAmountVat: 0,
            status: 0,
            documentNumber: "",
            documentDate: new Date(),
            comment: "",
            companyId: "",
            
            createdDate: new Date(),
            transactions: [],
        };
        return model;
    },
};
